import BasePopup from './BasePopup';
import AppLink from '../AppLink/AppLink';
import { RouteType } from 'enums/routeType';
import useTranslation from 'next-translate/useTranslation';
import { Namespace } from 'enums/namespaces';
import Analytics from 'helpers/Analytics';

interface Props {
  onClose?: () => void;
}

const BuySubscriptionPopup = ({ onClose }: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.Popups);

  return (
    <BasePopup showCloseIcon={false} classes={['subscription']} onClose={onClose}>
      <h2>{t('activate_subscription_title')}</h2>
      <p>{t('activate_subcription_content')}</p>
      <div className="buttons">
        <AppLink href={`/${RouteType.ChoosePlan}`}>
          <a className="btn">{t('activate_subscription_button')}</a>
        </AppLink>
      </div>
    </BasePopup>
  );
};

export default BuySubscriptionPopup;
